import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { APP_KEY, AppKey } from '@run-diffusion/shared';

export const DownloadModelInstructionsMixin = Vue.extend({
	computed: {
		...mapState([
			'toolbar',
			'preloadModel',
			'appOffersMap',
		]),
		...mapGetters([
			'sessionAppKey',
		]),
		// Resolves the session's AppKey from either legacy apps[0] or Mobius deploymentImage.
		currentSessionAppKey (): AppKey {
			const session = this.toolbar && this.toolbar.session;
			return session ? this.sessionAppKey(session) : null;
		},
		isFileBrowserSession () {
			return this.currentSessionAppKey === APP_KEY.FILE_001;
		},
		appOfferDisplayText () {
			const appKey = this.currentSessionAppKey;
			if (!appKey) return '';
			return this.appOffersMap[appKey] ? this.appOffersMap[appKey].label : appKey;
		},
		showAnyModelDropdownExampleScreenshot () {
			return !!(
				this.showAuto1111ModelDropdownExampleScreenshot ||
				this.showVladModelDropdownExampleScreenshot ||
				this.showFcusModelDropdownExampleScreenshot ||
				this.showInvkModelDropdownExampleScreenshot ||
				this.showEnfgModelDropdownExampleScreenshot ||
				this.showMkyoModelDropdownExampleScreenshot
			);
		},
		showAuto1111ModelDropdownExampleScreenshot () {
			return this.currentSessionAppKey === APP_KEY.AUTO_001;
		},
		showVladModelDropdownExampleScreenshot () {
			return this.currentSessionAppKey === APP_KEY.VLAD_001;
		},
		showFcusModelDropdownExampleScreenshot () {
			return this.currentSessionAppKey === APP_KEY.FCUS_001;
		},
		showInvkModelDropdownExampleScreenshot () {
			return this.currentSessionAppKey === APP_KEY.INVK_001;
		},
		showEnfgModelDropdownExampleScreenshot () {
			return this.currentSessionAppKey === APP_KEY.ENFG_001;
		},
		showMkyoModelDropdownExampleScreenshot () {
			return this.currentSessionAppKey === APP_KEY.MKYO_001;
		},
	},
});
